
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const SearchMember = () => {
  const [searchQuery, setSearchQuery] = useState(
    localStorage.getItem("searchQuery") || ""
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryFromUrl = params.get("search");

    if (queryFromUrl !== null) {
      setSearchQuery(queryFromUrl);
      localStorage.setItem("searchQuery", queryFromUrl);
    }
  }, [location.search]);

  const handleSearch = () => {
    const normalizedQuery = searchQuery.trim();
    localStorage.setItem("searchQuery", normalizedQuery);

    if (normalizedQuery) {
      navigate(
        `/danh-sach-hoi-vien?search=${encodeURIComponent(normalizedQuery)}`
      );
      return;
    }

    navigate("/danh-sach-hoi-vien");
  };

  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    localStorage.setItem("searchQuery", "");
  };

  return (
    <div
      className="input-group w-fit mt-2 relative"
      onClick={(event) => event.stopPropagation()}
    >
      <input
        type="text"
        placeholder="Tìm kiếm hội viên"
        className="input input-bordered input-sm w-36 focus:outline-none focus:ring-0"
        value={searchQuery}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {searchQuery && (
        <button
          type="button"
          className="absolute right-12 top-0 bottom-0 flex items-center text-gray-400 hover:text-gray-600"
          onClick={clearSearch}
          title="Xóa tìm kiếm"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
      <button
        type="button"
        className="btn btn-sm btn-outline flex items-center content-center capitalize hover:bg-base-100 hover:text-slate-500 text-slate-400 text-sm font-medium"
        onClick={handleSearch}
        title="Tìm kiếm thông tin hội viên"
      >
        <MagnifyingGlassIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default SearchMember;

